export default __webpack_public_path__ + "static/media/groundtruth-icon.1eb69aae.png";